var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("J-1-2a__HR_Resume")])}
var staticRenderFns = []

export { render, staticRenderFns }